import { LazyModule } from 'owa-bundling';

const lazyMarkJS = new LazyModule(
    () =>
        // markJS is the external library which highlights the search tokens
        import(/* webpackChunkName: "MarkJS" */ 'external-markjs')
);

/**
 * Utility function to highlight the search tokens provided
 * @param element The DOM element where the search tokens will be highlighted
 * @param highlightTerms Search tokens to be highlighted
 */
export async function highlightTermsInHtmlElement(element: HTMLElement, highlightTerms: string[]) {
    if (element) {
        let MarkJS = await lazyMarkJS.import();
        MarkJS = MarkJS.default || MarkJS; // WP3 and 4 compatibilty
        if (MarkJS) {
            const marker = MarkJS.call(MarkJS, element);
            if (highlightTerms) {
                // Unmark to undo any marking done previously to avoid nested marking
                marker.unmark({
                    done: () => {
                        marker.mark(highlightTerms);
                    },
                });
            } else {
                marker.unmark();
            }
        }
    }
}
